import axios from 'axios';
import pathfinder from '@fiverr-private/pathfinder';

interface CreateConversationResponse {
    conversationId: string;
    artifacts: { artifactId: string }[];
}

export interface AgenticBriefConversation {
    briefId: string;
    conversationId: string;
}

export const createAgenticBriefConversation = async (): Promise<AgenticBriefConversation> => {
    const url = pathfinder('ai_agents_create_conversation', {
        agentId: 'job-post-brief',
        apiVersion: 'v1',
    });

    const { data } = await axios.post<CreateConversationResponse>(url);
    const briefArtifact = Array.isArray(data?.artifacts) ? data.artifacts[0] : undefined;

    if (!briefArtifact) {
        throw new Error('createAgenticBriefConversation: conversation was created without a brief artifact');
    }

    if (!data?.conversationId) {
        throw new Error('createAgenticBriefConversation: conversation was created without a conversation id');
    }

    return { briefId: briefArtifact.artifactId, conversationId: data.conversationId };
};
